<div *ngIf="showWarning" class="text-danger">
  Op {{ warningTimes.join(' en ') }} moeten nieuwe meldingen door planning worden aangemaakt
</div>
